import React from "react";
import Header from "../components/UI/Header";
import env from "../env/env.json";

const Accueil = () => {
  const ville = env.ville;
  const reglement = env.reglement;
  const annexe_2 = env.annexe_2;
  const annexe_3 = env.annexe_3;
  return (
    <>
      <Header
        title="demande en ligne de changement d'usage à caractère personnel (ou usage
          mixte) d'un local d'habitation"
      />
      <section className="p-3">
        <p>
          Vous souhaitez obtenir une autorisation personnelle de changement
          d'usage (i.e. non soumise à compensation) pour exercer une activité
          professionnelle ou commerciale dans un local d'habitation&nbsp;?
          <br />
          Vous pouvez déposer votre demande de changement d'usage à l'aide du
          présent formulaire en ligne.
        </p>
        <p className="mt-4">
          Vous devez déposer une demande par adresse de changement d'usage.
        </p>
        <p>
          Les conditions fixées pour la délivrance de l’autorisation préalable
          du Maire résultent de la délibération du 27 mars 2024 du Conseil
          Municipal.
        </p>
        <a href={reglement} target="_blank" rel="noreferrer">
          Réglement des autorisations de changement d'usage
        </a>
        <p className="mt-3">
          Ce réglement fixe les conditions d’autorisations de changement d’usage
          de locaux d’habitation pour la Ville de {ville}.
        </p>
        <p>
          Lorsque le local à usage d’habitation constitue la résidence
          principale du loueur ou une partie, il n’y a pas lieu de solliciter
          une autorisation de changement d’usage pour le louer durant de courtes
          durées à une clientèle de passage qui n’y élit pas domicile.
        </p>
        <p className="fw-bold text-decoration-underline">
          Cette dispense n'est valable que si la durée de location cumulée
          n'excède pas 120 jours par an.
        </p>
        <p className="background--warning p-3 mt-4">
          <i className="fas fa-exclamation-triangle"></i>&nbsp;
          <strong>
            Nous vous recommandons de préparer toutes les pièces justificatives
            au format demandé (cf. la liste ci-dessous) avant de commencer la
            télédéclaration, et de compléter entièrement le formulaire jusqu'à
            l'étape de validation. En cas d'abandon, les informations
            renseignées ne seront pas enregistrées et vous devrez compléter le
            formulaire à nouveau. Tous les champs du formulaire sont
            obligatoires sauf mention contraire. Les pièces justificatives sont
            nécessaires à l'instruction de votre demande. Tout dossier incomplet
            ou insuffisamment renseigné fera l'objet d'une demande de pièces
            complémentaires, ce qui retardera son instruction.
          </strong>
        </p>
      </section>
      <section className="accordion w-100" id="accordion">
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse"
              aria-expanded="false"
              aria-controls="collapse"
            >
              Afficher les pièces justificatives à fournir
            </button>
          </h2>
          <div
            id="collapse"
            className="accordion-collapse collapse"
            aria-labelledby="heading"
            data-bs-parent="#accordion"
          >
            <div className="accordion-body">
              <p className="text-danger text-alert p-0 fw-bold">
                Les documents envoyés doivent être au format PDF, JPEG, JPG ou
                PNG et d'une taille maximale de 8 Mo par fichier.
              </p>
              <div>
                <h6 className="text-decoration-underline">
                  <i className="fas fa-arrow-right"></i>&nbsp;Pour les
                  particuliers propriétaires :
                </h6>
                <ul>
                  <li>
                    Pièce justificative d'identité en cours de validité (CNI,
                    passeport...) du/des propriétaires.
                  </li>
                  <li>
                    Plan côté du local objet de la demande, daté et signé par
                    le(s) demandeur(s), avec mention de la surface habitable
                    (conformément à l'article R.156-1 du Code de la Construction
                    et de l'Habitation).
                  </li>
                  <li>Titre d’occupation ou attestation de propriété.</li>
                  <li>
                    En cas d’accession à la propriété à prix maitrisée : copie
                    de l'acte authentique de vente.
                  </li>
                </ul>
              </div>
              <div>
                <h6 className="text-decoration-underline">
                  <i className="fas fa-arrow-right"></i>&nbsp;Pour les
                  particuliers locataires ou occupants à titre gratuit :
                </h6>
                <ul>
                  <li>
                    Pièce justificative d'identité en cours de validité (CNI,
                    passeport...) du/des propriétaires.
                  </li>
                  <li>
                    Plan côté du local objet de la demande, daté et signé par
                    le(s) demandeur(s), avec mention de la surface habitable
                    (conformément à l'article R.156-1 du Code de la Construction
                    et de l'Habitation).
                  </li>
                  <li>
                    Engagement du propriétaire si le demandeur est locataire ou
                    occupant à titre gratuit (
                    <a href={annexe_2} target="_blank" rel="noreferrer">
                      annexe 2
                    </a>
                    ).
                  </li>
                  <li>
                    Titre d’occupation ou attestation de propriété fourni par
                    le/les propriétaires.
                  </li>
                </ul>
              </div>
              <div>
                <h6 className="text-decoration-underline">
                  <i className="fas fa-arrow-right"></i>&nbsp;Pour les
                  particuliers bénéficiaires d'une promesse de vente :
                </h6>
                <ul>
                  <li>
                    Pièce justificative d'identité en cours de validité (CNI,
                    passeport...) du/des bénéficiaires de la promesse de vente.
                  </li>
                  <li>
                    Plan côté du local objet de la demande, daté et signé par
                    le(s) demandeur(s), avec mention de la surface habitable
                    (conformément à l'article R.156-1 du Code de la Construction
                    et de l'Habitation).
                  </li>
                  <li>Copie de la promesse de vente.</li>
                </ul>
              </div>
              <div>
                <h6 className="text-decoration-underline">
                  <i className="fas fa-arrow-right"></i>&nbsp;Pour les personnes
                  morales (sociétés, SCI, …) :
                </h6>
                <ul>
                  <li>Copie des statuts ou extrait de Kbis à jour.</li>
                  <li>
                    Plan côté du local objet de la demande, daté et signé par
                    le(s) demandeur(s), avec mention de la surface habitable
                    (conformément à l'article R.156-1 du Code de la Construction
                    et de l'Habitation).
                  </li>
                  <li>Titre d’occupation ou attestation de propriété.</li>
                </ul>
              </div>
              <div>
                <h6 className="text-decoration-underline">
                  <i className="fas fa-arrow-right"></i>&nbsp;Pour les
                  mandataires :
                </h6>
                <ul>
                  <li>
                    Pièce justificative d'identité en cours de validité (CNI,
                    passeport...) du mandataire.
                  </li>
                  <li>
                    Annexe signée justifiant du mandat (
                    <a href={annexe_3} target="_blank" rel="noreferrer">
                      annexe 3
                    </a>
                    ).
                  </li>
                  <li>
                    Pièce justificative d'identité en cours de validité (CNI,
                    passeport...) du/des propriétaires.
                  </li>
                  <li>
                    Plan côté du local objet de la demande, daté et signé par
                    le(s) demandeur(s), avec mention de la surface habitable
                    (conformément à l'article R.156-1 du Code de la Construction
                    et de l'Habitation).
                  </li>
                  <li>
                    Titre d’occupation ou attestation de propriété du/des
                    propriétaires.
                  </li>
                  <li>
                    Copie de l'acte authentique de vente en cas d’accession à la
                    propriété à prix maitrisée.
                  </li>
                </ul>
              </div>
              <div>
                <h6 className="text-decoration-underline">
                  <i className="fas fa-arrow-right"></i>&nbsp;Pièces
                  complémentaires pour les demandes de renouvellement :
                </h6>
                <ul>
                  <li>La copie de la précédente autorisation.</li>
                </ul>
              </div>
              <div className="background--warning p-4">
                <h6>
                  <i className="fas fa-exclamation-triangle"></i>
                  &nbsp;Tout dossier incomplet ou insuffisamment renseigné fera
                  l’objet d’une demande de pièces complémentaires, ce qui
                  retardera son instruction.
                </h6>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Accueil;
